import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'

import ElementPlus from 'element-plus'
import 'normalize.css/normalize.css'
import '@/apps/adok/app/styles/index.scss'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from '@/apps/adok/app/App.vue'

import router from '@/apps/adok/app/router'

import { installErrorLogger, installGtm } from '@/apps/adok/app/telemetry'

import { queryClient } from '@/shared/api'

import { reloadOnChunkError } from '@/support/chunkReload'

import appEnv from '@/support/env'

if (typeof String.prototype.replaceAll === 'undefined') {
  // eslint-disable-next-line
  String.prototype.replaceAll = function(match, replace) {
    // @ts-ignore:next-line
    return this?.replace(new RegExp(match, 'g'), () => replace)
  }
}

// @ts-ignore:next-line
const app = createApp(App)
const pinia = createPinia()

app.use(ElementPlus)
app.use(pinia)
app.use(VueQueryPlugin, { queryClient })
app.use(router)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(`${key}ElementIcon`, component)
}
// Do not add `useLoading(router)` here, the way `src/traforama.ts` does. Its `afterEach`
// writes `[<id>] <meta.title>` with no product name, and it would register *after* the one
// in `app/router.ts` — this line runs long after the router module was imported, and
// vue-router calls `afterEach` guards in registration order. The last writer wins, so the
// tab would lose `| Adok.ai …` on every titled route. The title is written in
// `app/router.ts` and nowhere else.
installGtm(app, router)
// Before the router runs: the first navigation is where a stale tab meets a chunk that
// no longer exists, and this is what turns that dead end into one reload.
reloadOnChunkError()

installErrorLogger(app, router, appEnv.SENTRY_DSN)

app.mount('#app')
